"use strict";
var tab_component_1 = require("./tab.component");
exports.NguiTabComponent = tab_component_1.NguiTabComponent;
var tab_module_1 = require("./tab.module");
exports.NguiTabModule = tab_module_1.NguiTabModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/tab/dist/index.js
// module id = 577
// module chunks = 4